var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLabExperienceUser)?_c('section',{staticClass:"labs-experience-main"},[(_vm.showSkillDive)?[_c('LabExperienceEnhanced')]:[_c('LabExperienceRegular')]],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }